export const LOG_IN = 'LOG_IN'
export const LOG_OUT = 'LOG_OUT'
export const CHECK_AUTH = 'CHECK_AUTH'
export const UPDATE_LOGIN = 'UPDATE_LOGIN'



// WEBPACK FOOTER //
// ./src/store/MutationTypes.js